import { IMenu } from "pages/[tenant]/cp/@types";

import { captureException, captureMessage } from "@sentry/nextjs";

const menuItemsSessionStorageKey = "menu-items";

export const saveMenuItemsInSessionStorage = (menuItems: IMenu[]): void => {
  try {
    sessionStorage?.setItem(
      menuItemsSessionStorageKey,
      JSON.stringify(menuItems),
    );
  } catch (error) {
    console.log("Erro (saveMenuItemsInSessionStorage): ", error);
    captureException(error);
    captureMessage("Erro (saveMenuItemsInSessionStorage)");
  }
};

export const getMenuItemsFromSessionStorage = (): IMenu[] => {
  try {
    const menusFromSessionStorage = JSON.parse(
      sessionStorage?.getItem(menuItemsSessionStorageKey) ?? "[]",
    );

    return menusFromSessionStorage;
  } catch (error) {
    console.log("Erro (getMenuItemsFromSessionStorage): ", error);
    captureException(error);
    captureMessage("Erro (getMenuItemsFromSessionStorage)");
  }
};

export const updateItemMenuInSessionStorage = (item: IMenu) => {
  const menusSaved = getMenuItemsFromSessionStorage();

  const updatedMenus = menusSaved.map((menu) =>
    menu?.id === item?.id ? item : menu,
  );

  saveMenuItemsInSessionStorage(updatedMenus);
};

export const removeItemMenuInSessionStorage = (item: IMenu) => {
  const menusSaved = getMenuItemsFromSessionStorage();

  const updatedMenus = menusSaved.filter((menu) => menu?.id !== item?.id);

  saveMenuItemsInSessionStorage(updatedMenus);
};
